/**
 * vue quill editor 配置
 */
import localStorage from 'store';

// 图片上传配置
const uploadConfig = {
  // action:  '/app/upload_quill_image',      // 必填，图片上传地址
  action:  'https://adminapi.love1234.com/app/upload_quill_image', // 线上
  // action:  'http://adminapi.kuaiqian.com/app/upload_quill_image', // 本地

  methods: 'POST',          // 必填，图片上传方式
  name: 'quillImage',       // 必填，文件的参数名
  size: 2048,               // 可选，图片大小，单位为Kb, 1M = 1024Kb
  accept: 'image/png, image/gif, image/jpeg',  // 可选，可上传的图片格式
  width: 600,
  height: 600
};

/**
 * 上传图片文件，成功返回 path
 */
function uploadImageFile(file, onSuccess, onError) {
  let formData = new FormData();
  formData.append(uploadConfig.name, file);
  formData.append('object', 'product');

  let xhr = new XMLHttpRequest();
  xhr.open(uploadConfig.methods, uploadConfig.action, true);

  let token = localStorage.get('admin.token');
  if (token) {
    xhr.setRequestHeader('token', token);
  }

  xhr.onload = function () {
    if (xhr.status === 200) {
      let res = JSON.parse(xhr.responseText);
      if (res.code == '200' && res.data && res.data.path) {
        onSuccess && onSuccess(res.data.path);
        return;
      }
    }
    onError && onError(xhr);
  };
  xhr.onerror = function () {
    onError && onError(xhr);
  };
  xhr.send(formData);
}

/**
 * 粘贴图片时走上传（工具栏上传本身已支持）
 * 在 quill-editor 的 @ready 里调用一次即可
 */
export function bindQuillPasteImage(quill) {
  if (!quill || quill.__bindPasteImage) {
    return;
  }
  quill.__bindPasteImage = true;

  quill.root.addEventListener('paste', function (e) {
    let items = (e.clipboardData && e.clipboardData.items) || [];
    let imageItem = null;
    for (let i = 0; i < items.length; i++) {
      if (items[i].type && items[i].type.indexOf('image') === 0) {
        imageItem = items[i];
        break;
      }
    }
    if (!imageItem) {
      return;
    }

    // 拦截默认粘贴（避免插入 data:image）
    e.preventDefault();
    e.stopPropagation();

    let file = imageItem.getAsFile();
    if (!file) {
      return;
    }

    uploadImageFile(file, function (path) {
      let range = quill.getSelection(true) || { index: quill.getLength() };
      quill.insertEmbed(range.index, 'image', path);
      quill.setSelection(range.index + 1);
    }, function () {
      console.error('粘贴图片上传失败');
    });
  }, true);
}

// 工具栏选项配置
const toolOptions = [
  ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
  // ["blockquote", "code-block"], // 引用  代码块
  // [{ 'header': 1 }, { 'header': 2 }], // 标题
  //[{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
  // [{ script: "sub" }, { script: "super" }], // 上标/下标
  //[{ indent: "-1" }, { indent: "+1" }], // 缩进
  // [{'direction': 'rtl'}],            // 文本方向
  // [{ size: ["small", false, "large", "huge"] }], // 字体大小
  //[{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
  [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
  // [{ font: [] }], // 字体种类
  //[{ align: [] }], // 对齐方式
  ["clean"], // 清除文本格式
  //["link", "image", "video"] // 链接、图片、视频
  ["link", "image", "video"] // 链接、图片、视频
];

// 事件重写
const handlers = {
  image: function image() {
    console.log(uploadConfig);
    let self = this;

    let fileInput = this.container.querySelector('input.ql-image[type=file]');
    if(fileInput == null) {
      fileInput = document.createElement('input');
      fileInput.setAttribute('type', 'file');
      // 设置图片参数名
      if(uploadConfig.name) {
        fileInput.setAttribute('name', uploadConfig.name);
      }

      // 设置上传图片的格式
      fileInput.setAttribute('accept', uploadConfig.accept);
      fileInput.classList.add('ql-image');

      // 监听选择文件事件
      fileInput.addEventListener('change', function() {
        if (!fileInput.files || !fileInput.files[0]) {
          return;
        }
        uploadImageFile(fileInput.files[0], function (path) {
          let length = self.quill.getSelection(true).index;
          console.log('path:' + path);
          self.quill.insertEmbed(length, 'image', path);
          self.quill.setSelection(length + 1);
          fileInput.value = '';
        }, function () {
          console.error('quill上传失败');
          fileInput.value = '';
        });
      });
      this.container.appendChild(fileInput);
    }
    fileInput.click();
  }
};

export default {
  placeholder: '',
  theme: 'snow',  // 主题
  modules: {
    toolbar: {
      container: toolOptions,   // 工具栏选项
      handlers: handlers        // 事件重写
    }
  }
}
